// Computed in UTC so a day never shifts with the browser's time zone or DST.
const pad = n => String(n).padStart(2, "0")

export const toISO = date =>
  `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`

export const parseISO = iso => {
  const [year, month, day] = iso.split("-").map(Number)
  return new Date(Date.UTC(year, month - 1, day))
}

export const addDays = (iso, count) => {
  const date = parseISO(iso)
  date.setUTCDate(date.getUTCDate() + count)
  return toISO(date)
}

export const diffDays = (from, to) => Math.round((parseISO(to) - parseISO(from)) / 86400000)

export const mondayOf = iso => addDays(iso, -((parseISO(iso).getUTCDay() + 6) % 7))

export const todayISO = () => {
  const now = new Date()
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
}

export const isWeekend = iso => [0, 6].includes(parseISO(iso).getUTCDay())

export const datesBetween = (from, to) => {
  const dates = []
  for (let iso = from; iso <= to; iso = addDays(iso, 1)) dates.push(iso)
  return dates
}

const formatter = options => new Intl.DateTimeFormat(I18n.locale || "fr", { ...options, timeZone: "UTC" })

export const weekdayShort = iso => formatter({ weekday: "short" }).format(parseISO(iso)).replace(".", "")
export const dayNumber    = iso => parseISO(iso).getUTCDate()
export const formatShort  = iso => formatter({ day: "numeric", month: "short" }).format(parseISO(iso))
export const formatLong   = iso => formatter({ weekday: "long", day: "numeric", month: "long" }).format(parseISO(iso))

export const formatPeriod = (from, to) => {
  const sameYear = from.slice(0, 4) === to.slice(0, 4)
  const start = formatter(sameYear ? { day: "numeric", month: "short" } : { day: "numeric", month: "short", year: "numeric" })
  return `${start.format(parseISO(from))} – ${formatter({ day: "numeric", month: "short", year: "numeric" }).format(parseISO(to))}`
}

export const isoWeek = iso => {
  const date = parseISO(iso)
  const thursday = new Date(date)
  thursday.setUTCDate(date.getUTCDate() + 3 - ((date.getUTCDay() + 6) % 7))
  const firstThursday = new Date(Date.UTC(thursday.getUTCFullYear(), 0, 4))
  return 1 + Math.round(((thursday - firstThursday) / 86400000 - 3 + ((firstThursday.getUTCDay() + 6) % 7)) / 7)
}
